// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === MAIN PAGE & WRAPPER === */
.shipment-page {
  animation: fadeIn 0.3s ease-in-out;
}
.page-content-wrapper {
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid #f3f4f6;
  padding: 24px;
}

/* === HEADER (TABS & CONTROLS) === */
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.shipment-tabs {
  flex-grow: 1; /* Allow tabs to take up available space */
}
.shipment-tabs button {
  background: none;
  border: none;
  padding: 0 5px 16px 5px;
  margin-right: 30px;
  font-size: 16px;
  color: #174078;
  cursor: pointer;
  position: relative;
  font-weight: 500;
}
.shipment-tabs button.active {
  color: #f97316;
  font-weight: 600;
  border-bottom: 4px solid #f97316;
}
.page-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.filter-btn.small {
  display: flex;
  background-color: #fff4ec;
  color: #ff8a00;
  border: none;
  border-radius: 6px;
  padding: 10px;
  font-size: 18px;
  cursor: pointer;
}
.input-with-icon.search-bar {
  position: relative;
  width: 280px;
  background: none;
  border: 2px solid #f3f4f6;
  box-shadow: none;
  border-radius: 0; /* Ensures the border is a box shape */
  padding: 3px 7px; /* Reduce padding to make the search bar less tall */
  font-size: 14px; /* Adjust font size if needed */
}
.input-with-icon.search-bar input {
  background: none;
  border: none !important;
  border-radius: 6px;
  padding: 10px 12px 10px 32px; /* Adjusted left padding to bring the icon closer */
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  box-shadow: none;
}
.input-with-icon.search-bar svg {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  font-size: 18px;
  color: #9ca3af;
  pointer-events: none;
}

/* === MAIN CONTENT AREA === */
/* .shipment-content {
  padding-top: 0;
} */
.shipment-content {
  padding-top: 0;
  height: auto; /* Let it grow based on content initially */
  min-height: 600px; /* Default height */
  /* max-height: 500px; Limit to this height */
  overflow-y: auto; /* Scroll if content exceeds max-height */
}

/* === SHIPMENT PRICING TAB === */
.display-settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 32px 24px; /* row-gap column-gap */
}
.settings-display-column {
  display: flex;
  flex-direction: column;
}
.settings-display-column h4 {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 16px 0;
}
.tags-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}
.tag {
  background: none;
  border: 1px solid #e2e8f0;
  padding: 6px 12px;
  margin: 0;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  background-color: #f1f5f9;
  color: #475569;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.tag:hover {
  border-color: #fdba74;
}
.tag.selected {
  background-color: #fef3c7;
  color: #92400e;
  border-color: #fbbf24;
  font-weight: 600;
}
.add-tag-btn,
.set-price-btn {
  background: none;
  border: 1px dashed #ffb482;
  color: #f97316;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  width: fit-content;
  margin-top: 4px;
}
.set-price-btn {
  border-style: solid;
  background-color: #f97316;
  color: white;
  padding: 8px 24px;
}
.set-price-btn:disabled {
  background-color: #fdba74;
  border-color: #fdba74;
  cursor: not-allowed;
}

/* === CUSTOMER SHIPMENTS TAB & GENERAL TABLE STYLES === */
.table-container {
  overflow-x: auto;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
}
.data-table th,
.data-table td {
  padding: 16px 20px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
  font-size: 14px;
}
.data-table th {
  color: #1e3a8a;
  font-weight: 600;
  background-color: #f2f7ff;
}
.data-table td {
  color: #374151;
}
.data-table tbody tr:last-child td {
  border-bottom: none;
}
.action-cell {
  text-align: center;
  vertical-align: middle;
}
.action-cell .action-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
}
.action-icon {
  font-size: 20px;
  color: #9ca3af;
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.status-badge {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}
.status-pending {
  background-color: #fef9c3;
  color: #854d0e;
}
.status-processing {
  background-color: #e0e7ff;
  color: #3730a3;
}
.status-checked_in {
  background-color: #dcfce7;
  color: #166534;
}
.status-declined {
  background-color: #fee2e2;
  color: #991b1b;
}

/* Add other status colors as needed */

/* === EDIT FORM VIEW STYLES === */
.edit-settings-view {
  display: grid;
  grid-template-columns: 2fr 1.5fr;
  gap: 80px;
}
.form-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-group-header h4 {
  font-size: 16px;
  font-weight: 500;
  color: #1e3a8a;
  margin: 0;
}
.edit-btn {
  background: none;
  border: 1px solid #f97316;
  color: #f97316;
  border-radius: 16px;
  padding: 4px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.form-group-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.input-container {
  position: relative;
}
.input-container input {
  width: 100%;
  background: #f3f3f3;
  border: none;
  outline: none;
  font-size: 14px;
  color: #ababab;
  padding: 12px 16px;
  border-radius: 8px;
}
.input-container svg {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #9ca3af;
}
.radio-group {
  display: flex;
  gap: 32px;
  padding-top: 8px;
}
.radio-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
  color: #1e3a8a;
}
.radio-label input[type="radio"] {
  position: absolute;
  opacity: 0;
}
.custom-radio {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #f97316;
  position: relative;
}
.radio-label input[type="radio"]:checked + .custom-radio::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #f97316;
}
.form-actions-full-width {
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
}
.save-btn {
  background-color: #f97316;
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

/* --- RESPONSIVE STYLES --- */
@media (max-width: 1200px) {
  .page-content-wrapper {
    padding: 16px;
  }
  .display-settings-grid {
    gap: 20px 12px;
  }
}

@media (max-width: 992px) {
  .content-header {
    flex-direction: column;
    gap: 1rem;
  }
  .page-content-wrapper {
    padding: 12px;
  }
  .shipment-tabs {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}

@media (max-width: 768px) {
  .page-content-wrapper {
    padding: 8px;
  }
  .display-settings-grid {
    grid-template-columns: 1fr;
  }
  .form-group-row {
    grid-template-columns: 1fr;
  }
  .table-container {
    overflow-x: auto;
  }
  .data-table thead {
    display: none;
  }
  .data-table tr {
    display: block;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    margin-bottom: 1rem;
    padding: 1rem;
  }
  .data-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f3f4f6;
    white-space: normal;
  }
  .data-table td:last-child {
    border-bottom: none;
  }
  .data-table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #4b5563;
    text-align: left;
  }
}

/* SETTINGS TABLE CSS */

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.header h1 {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  color: #1f2937;
}

.tabs {
  margin-bottom: 24px;
}

.tabs-list {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 24px;
}

.tab-trigger {
  padding: 12px 24px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}

.tab-trigger.active {
  color: #f97316;
  border-bottom-color: #f97316;
}

.tab-trigger:hover {
  color: #f97316;
}

.card {
  background: white;
  /* border: 1px solid #e5e7eb; */
  border-radius: 8px;

  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */
  /* margin-bottom: 10px; */
}

.card-header {
  /* padding: 20px 24px; */
  /* background: #92400e; */
  /* border-bottom: 1px solid #e5e7eb; */
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #1f2937;
}

.card-content {
  /* padding: 24px; */
}

.form-section {
  margin-bottom: 32px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
}

.form-input,
.form-select {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.radio-group {
  display: flex;
  gap: 24px;
  margin-top: 8px;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.radio-input {
  width: 16px;
  height: 16px;
  accent-color: #f97316;
}

.radio-label {
  font-size: 14px;
  color: #374151;
  cursor: pointer;
}

.button {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.button-primary {
  background-color: #f97316;
  color: white;
}

.button-primary:hover {
  background-color: #ea580c;
}

.button-secondary {
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}

.button-secondary:hover {
  background-color: #e5e7eb;
}

.table-container {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

/* .table th {
  color: #1e3a8a;
  font-weight: 600;
  background-color: #f2f7ff;
} */

.table th,
.table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

.table th {
  color: #1e3a8a;
  font-weight: 600;
  background-color: #f2f7ff;
}

.table td {
  font-size: 14px;
  color: #6b7280;
}

.table tbody tr:hover {
  background-color: #f9fafb;
}

.badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.badge-secondary {
  background-color: #f3f4f6;
  color: #374151;
}

.badge-outline {
  background-color: transparent;
  border: 1px solid #d1d5db;
  color: #374151;
}

.badge-pending {
  background-color: #fef3c7;
  color: #92400e;
}

.actions {
  display: flex;
  gap: 8px;
}

.icon-button {
  padding: 6px;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  color: #6b7280;
  transition: all 0.2s;
}

.icon-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}

.search-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-bottom: 16px; */
}

.search-input {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  width: 250px;
  font-size: 14px;
}

.currency {
  font-weight: 600;
  color: #059669;
}

.route {
  font-size: 13px;
}

.shipment-id {
  font-family: monospace;
  font-size: 12px;
  color: #6b7280;
}

/* Add these styles to your CSS file */
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.empty-content {
  text-align: center;
  width: 330px;
  height: 330px;
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 50%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.empty-content img {
  width: 85px;
  height: 85px;
  margin-bottom: 14px;
}

.empty-content h3 {
  font-size: 17px;
  font-weight: 600;
  color: #1e3a8a;
  margin: 0;
}

.empty-content p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  max-width: 80%;
}

.empty-content .button.button-primary {
  margin-top: 16px;
  background-color: #f97316;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.empty-content .button.button-primary:hover {
  background-color: #ea580c;
}

.form-field-container {
  position: relative;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e9ecef;
}

.form-field-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.edit-button {
  background: none;
  border: none;
  color: #f97316;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

.edit-button:hover {
  color: #ea580c;
}

.selected-value {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  color: #495057;
  margin-bottom: 8px;
}

.close-button {
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  font-size: 16px;
  padding: 0;
  margin-left: 8px;
}

.close-button:hover {
  color: #495057;
}

.form-grid-custom {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 24px;
}

.delivery-type-section {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e9ecef;
  margin-top: 20px;
}

.delivery-type-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.radio-group-custom {
  display: flex;
  gap: 32px;
}

.radio-item-custom {
  display: flex;
  align-items: center;
  gap: 8px;
}

.radio-input-custom {
  width: 20px;
  height: 20px;
  accent-color: #f97316;
}

.radio-label-custom {
  font-size: 14px;
  color: #495057;
  cursor: pointer;
  font-weight: 500;
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .radio-group {
    flex-direction: column;
    gap: 12px;
  }

  .search-container {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }

  .search-input {
    width: 100%;
  }

  .form-grid-custom {
    grid-template-columns: 1fr;
  }

  .radio-group-custom {
    flex-direction: column;
    gap: 16px;
  }
}

/* Add these styles for toast notifications */
.Toastify__toast-container {
  width: 320px;
}

.Toastify__toast {
  border-radius: 8px;
  font-family: inherit;
  margin-bottom: 1rem;
}

.Toastify__toast--success {
  background: #4caf50;
  color: white;
}

.Toastify__toast--error {
  background: #f44336;
  color: white;
}

.Toastify__toast-body {
  font-size: 14px;
  padding: 12px;
  line-height: 1.4;
}

.Toastify__progress-bar {
  background: rgba(255, 255, 255, 0.7);
}

/* Add these styles if you want to customize the close button */
.Toastify__close-button {
  color: white;
  opacity: 0.7;
}

.Toastify__close-button:hover {
  opacity: 1;
}

.button-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.status-dropdown-select {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  border: none; /* Remove border */
  background-color: transparent; /* Make background transparent */
  cursor: pointer;
  min-width: 150px;
  appearance: none; /* Remove default dropdown appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  position: relative;
  color: #374151; /* Default text color */
}

.status-dropdown:focus {
  outline: none;
  border-color: #f97316;
}

/* Status-specific colors */
.status-dropdown.status-pending {
  color: #ca8a04;
  background-color: #fef9c3;
}
.status-dropdown.status-in-transit {
  color: #854d0e;
  background-color: #fef9c3;
}
.status-dropdown.status-completed {
  color: #166534;
  background-color: #dcfce7;
}
.status-dropdown.status-canceled {
  color: #991b1b;
  background-color: #fee2e2;
}

.status-dropdown.status-declined {
  color: #991b1b;
  background-color: #fee2e2;
}
.status-dropdown.status-processing {
  color: #1d4ed8;
  background-color: #dbeafe;
}
/* Add more status-specific colors as needed */

.status-loading-select {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #6b7280;
  padding: 6px 12px;
}

.status-spinner-select {
  width: 12px;
  height: 12px;
  border: 2px solid #f3f4f6;
  border-top: 2px solid #f97316;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShipmentPage/ShipmentPage.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY,EAAE,0CAA0C;AAC1D;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB,EAAE,sCAAsC;EACxD,gBAAgB,EAAE,oDAAoD;EACtE,eAAe,EAAE,+BAA+B;AAClD;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B,EAAE,mDAAmD;EACjF,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;;GAEG;AACH;EACE,cAAc;EACd,YAAY,EAAE,2CAA2C;EACzD,iBAAiB,EAAE,mBAAmB;EACtC,4CAA4C;EAC5C,gBAAgB,EAAE,yCAAyC;AAC7D;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc,EAAE,uBAAuB;AACzC;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sCAAsC;;AAEtC,kCAAkC;AAClC;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA,uBAAuB;;AAEvB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;;EAElB,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;;GAIG;;AAEH;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA,6CAA6C;AAC7C;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,+DAA+D;AAC/D;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY,EAAE,kBAAkB;EAChC,6BAA6B,EAAE,gCAAgC;EAC/D,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE,uCAAuC;EACzD,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA,8CAA8C;;AAE9C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* === MAIN PAGE & WRAPPER === */\n.shipment-page {\n  animation: fadeIn 0.3s ease-in-out;\n}\n.page-content-wrapper {\n  background-color: #ffffff;\n  border-radius: 12px;\n  border: 1px solid #f3f4f6;\n  padding: 24px;\n}\n\n/* === HEADER (TABS & CONTROLS) === */\n.content-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.shipment-tabs {\n  flex-grow: 1; /* Allow tabs to take up available space */\n}\n.shipment-tabs button {\n  background: none;\n  border: none;\n  padding: 0 5px 16px 5px;\n  margin-right: 30px;\n  font-size: 16px;\n  color: #174078;\n  cursor: pointer;\n  position: relative;\n  font-weight: 500;\n}\n.shipment-tabs button.active {\n  color: #f97316;\n  font-weight: 600;\n  border-bottom: 4px solid #f97316;\n}\n.page-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.filter-btn.small {\n  display: flex;\n  background-color: #fff4ec;\n  color: #ff8a00;\n  border: none;\n  border-radius: 6px;\n  padding: 10px;\n  font-size: 18px;\n  cursor: pointer;\n}\n.input-with-icon.search-bar {\n  position: relative;\n  width: 280px;\n  background: none;\n  border: 2px solid #f3f4f6;\n  box-shadow: none;\n  border-radius: 0; /* Ensures the border is a box shape */\n  padding: 3px 7px; /* Reduce padding to make the search bar less tall */\n  font-size: 14px; /* Adjust font size if needed */\n}\n.input-with-icon.search-bar input {\n  background: none;\n  border: none !important;\n  border-radius: 6px;\n  padding: 10px 12px 10px 32px; /* Adjusted left padding to bring the icon closer */\n  font-size: 14px;\n  width: 100%;\n  box-sizing: border-box;\n  outline: none;\n  box-shadow: none;\n}\n.input-with-icon.search-bar svg {\n  position: absolute;\n  top: 50%;\n  left: 14px;\n  transform: translateY(-50%);\n  font-size: 18px;\n  color: #9ca3af;\n  pointer-events: none;\n}\n\n/* === MAIN CONTENT AREA === */\n/* .shipment-content {\n  padding-top: 0;\n} */\n.shipment-content {\n  padding-top: 0;\n  height: auto; /* Let it grow based on content initially */\n  min-height: 600px; /* Default height */\n  /* max-height: 500px; Limit to this height */\n  overflow-y: auto; /* Scroll if content exceeds max-height */\n}\n\n/* === SHIPMENT PRICING TAB === */\n.display-settings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 32px 24px; /* row-gap column-gap */\n}\n.settings-display-column {\n  display: flex;\n  flex-direction: column;\n}\n.settings-display-column h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 16px 0;\n}\n.tags-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n.tag {\n  background: none;\n  border: 1px solid #e2e8f0;\n  padding: 6px 12px;\n  margin: 0;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  display: inline-flex;\n  background-color: #f1f5f9;\n  color: #475569;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n.tag:hover {\n  border-color: #fdba74;\n}\n.tag.selected {\n  background-color: #fef3c7;\n  color: #92400e;\n  border-color: #fbbf24;\n  font-weight: 600;\n}\n.add-tag-btn,\n.set-price-btn {\n  background: none;\n  border: 1px dashed #ffb482;\n  color: #f97316;\n  padding: 4px 12px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  width: fit-content;\n  margin-top: 4px;\n}\n.set-price-btn {\n  border-style: solid;\n  background-color: #f97316;\n  color: white;\n  padding: 8px 24px;\n}\n.set-price-btn:disabled {\n  background-color: #fdba74;\n  border-color: #fdba74;\n  cursor: not-allowed;\n}\n\n/* === CUSTOMER SHIPMENTS TAB & GENERAL TABLE STYLES === */\n.table-container {\n  overflow-x: auto;\n}\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.data-table th,\n.data-table td {\n  padding: 16px 20px;\n  text-align: left;\n  border-bottom: 1px solid #f3f4f6;\n  font-size: 14px;\n}\n.data-table th {\n  color: #1e3a8a;\n  font-weight: 600;\n  background-color: #f2f7ff;\n}\n.data-table td {\n  color: #374151;\n}\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n.action-cell {\n  text-align: center;\n  vertical-align: middle;\n}\n.action-cell .action-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n}\n.action-icon {\n  font-size: 20px;\n  color: #9ca3af;\n  vertical-align: middle;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n.status-pending {\n  background-color: #fef9c3;\n  color: #854d0e;\n}\n.status-processing {\n  background-color: #e0e7ff;\n  color: #3730a3;\n}\n.status-checked_in {\n  background-color: #dcfce7;\n  color: #166534;\n}\n.status-declined {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n/* Add other status colors as needed */\n\n/* === EDIT FORM VIEW STYLES === */\n.edit-settings-view {\n  display: grid;\n  grid-template-columns: 2fr 1.5fr;\n  gap: 80px;\n}\n.form-column {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.form-group-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.form-group-header h4 {\n  font-size: 16px;\n  font-weight: 500;\n  color: #1e3a8a;\n  margin: 0;\n}\n.edit-btn {\n  background: none;\n  border: 1px solid #f97316;\n  color: #f97316;\n  border-radius: 16px;\n  padding: 4px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.form-group-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n.input-container {\n  position: relative;\n}\n.input-container input {\n  width: 100%;\n  background: #f3f3f3;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  color: #ababab;\n  padding: 12px 16px;\n  border-radius: 8px;\n}\n.input-container svg {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 16px;\n  color: #9ca3af;\n}\n.radio-group {\n  display: flex;\n  gap: 32px;\n  padding-top: 8px;\n}\n.radio-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #1e3a8a;\n}\n.radio-label input[type=\"radio\"] {\n  position: absolute;\n  opacity: 0;\n}\n.custom-radio {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid #f97316;\n  position: relative;\n}\n.radio-label input[type=\"radio\"]:checked + .custom-radio::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #f97316;\n}\n.form-actions-full-width {\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: flex-end;\n}\n.save-btn {\n  background-color: #f97316;\n  color: white;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n/* --- RESPONSIVE STYLES --- */\n@media (max-width: 1200px) {\n  .page-content-wrapper {\n    padding: 16px;\n  }\n  .display-settings-grid {\n    gap: 20px 12px;\n  }\n}\n\n@media (max-width: 992px) {\n  .content-header {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  .page-content-wrapper {\n    padding: 12px;\n  }\n  .shipment-tabs {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .page-content-wrapper {\n    padding: 8px;\n  }\n  .display-settings-grid {\n    grid-template-columns: 1fr;\n  }\n  .form-group-row {\n    grid-template-columns: 1fr;\n  }\n  .table-container {\n    overflow-x: auto;\n  }\n  .data-table thead {\n    display: none;\n  }\n  .data-table tr {\n    display: block;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n    padding: 1rem;\n  }\n  .data-table td {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid #f3f4f6;\n    white-space: normal;\n  }\n  .data-table td:last-child {\n    border-bottom: none;\n  }\n  .data-table td::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: #4b5563;\n    text-align: left;\n  }\n}\n\n/* SETTINGS TABLE CSS */\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 24px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.header h1 {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 0;\n  color: #1f2937;\n}\n\n.tabs {\n  margin-bottom: 24px;\n}\n\n.tabs-list {\n  display: flex;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 24px;\n}\n\n.tab-trigger {\n  padding: 12px 24px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6b7280;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s;\n}\n\n.tab-trigger.active {\n  color: #f97316;\n  border-bottom-color: #f97316;\n}\n\n.tab-trigger:hover {\n  color: #f97316;\n}\n\n.card {\n  background: white;\n  /* border: 1px solid #e5e7eb; */\n  border-radius: 8px;\n\n  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */\n  /* margin-bottom: 10px; */\n}\n\n.card-header {\n  /* padding: 20px 24px; */\n  /* background: #92400e; */\n  /* border-bottom: 1px solid #e5e7eb; */\n}\n\n.card-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n  color: #1f2937;\n}\n\n.card-content {\n  /* padding: 24px; */\n}\n\n.form-section {\n  margin-bottom: 32px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 6px;\n}\n\n.form-input,\n.form-select {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.form-input:focus,\n.form-select:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n.radio-group {\n  display: flex;\n  gap: 24px;\n  margin-top: 8px;\n}\n\n.radio-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.radio-input {\n  width: 16px;\n  height: 16px;\n  accent-color: #f97316;\n}\n\n.radio-label {\n  font-size: 14px;\n  color: #374151;\n  cursor: pointer;\n}\n\n.button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.button-primary {\n  background-color: #f97316;\n  color: white;\n}\n\n.button-primary:hover {\n  background-color: #ea580c;\n}\n\n.button-secondary {\n  background-color: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.button-secondary:hover {\n  background-color: #e5e7eb;\n}\n\n.table-container {\n  overflow-x: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n/* .table th {\n  color: #1e3a8a;\n  font-weight: 600;\n  background-color: #f2f7ff;\n} */\n\n.table th,\n.table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.table th {\n  color: #1e3a8a;\n  font-weight: 600;\n  background-color: #f2f7ff;\n}\n\n.table td {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.table tbody tr:hover {\n  background-color: #f9fafb;\n}\n\n.badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.badge-secondary {\n  background-color: #f3f4f6;\n  color: #374151;\n}\n\n.badge-outline {\n  background-color: transparent;\n  border: 1px solid #d1d5db;\n  color: #374151;\n}\n\n.badge-pending {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.actions {\n  display: flex;\n  gap: 8px;\n}\n\n.icon-button {\n  padding: 6px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 4px;\n  color: #6b7280;\n  transition: all 0.2s;\n}\n\n.icon-button:hover {\n  background-color: #f3f4f6;\n  color: #374151;\n}\n\n.search-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* margin-bottom: 16px; */\n}\n\n.search-input {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  width: 250px;\n  font-size: 14px;\n}\n\n.currency {\n  font-weight: 600;\n  color: #059669;\n}\n\n.route {\n  font-size: 13px;\n}\n\n.shipment-id {\n  font-family: monospace;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* Add these styles to your CSS file */\n.empty-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n.empty-content {\n  text-align: center;\n  width: 330px;\n  height: 330px;\n  background-color: #f9f9f9;\n  padding: 10px;\n  border-radius: 50%;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n}\n\n.empty-content img {\n  width: 85px;\n  height: 85px;\n  margin-bottom: 14px;\n}\n\n.empty-content h3 {\n  font-size: 17px;\n  font-weight: 600;\n  color: #1e3a8a;\n  margin: 0;\n}\n\n.empty-content p {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n  max-width: 80%;\n}\n\n.empty-content .button.button-primary {\n  margin-top: 16px;\n  background-color: #f97316;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.empty-content .button.button-primary:hover {\n  background-color: #ea580c;\n}\n\n.form-field-container {\n  position: relative;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 16px;\n  border: 1px solid #e9ecef;\n}\n\n.form-field-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.edit-button {\n  background: none;\n  border: none;\n  color: #f97316;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n}\n\n.edit-button:hover {\n  color: #ea580c;\n}\n\n.selected-value {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 14px;\n  color: #495057;\n  margin-bottom: 8px;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  color: #6c757d;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 0;\n  margin-left: 8px;\n}\n\n.close-button:hover {\n  color: #495057;\n}\n\n.form-grid-custom {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.delivery-type-section {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 16px;\n  border: 1px solid #e9ecef;\n  margin-top: 20px;\n}\n\n.delivery-type-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.radio-group-custom {\n  display: flex;\n  gap: 32px;\n}\n\n.radio-item-custom {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.radio-input-custom {\n  width: 20px;\n  height: 20px;\n  accent-color: #f97316;\n}\n\n.radio-label-custom {\n  font-size: 14px;\n  color: #495057;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n@media (max-width: 768px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .radio-group {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .search-container {\n    flex-direction: column;\n    gap: 16px;\n    align-items: stretch;\n  }\n\n  .search-input {\n    width: 100%;\n  }\n\n  .form-grid-custom {\n    grid-template-columns: 1fr;\n  }\n\n  .radio-group-custom {\n    flex-direction: column;\n    gap: 16px;\n  }\n}\n\n/* Add these styles for toast notifications */\n.Toastify__toast-container {\n  width: 320px;\n}\n\n.Toastify__toast {\n  border-radius: 8px;\n  font-family: inherit;\n  margin-bottom: 1rem;\n}\n\n.Toastify__toast--success {\n  background: #4caf50;\n  color: white;\n}\n\n.Toastify__toast--error {\n  background: #f44336;\n  color: white;\n}\n\n.Toastify__toast-body {\n  font-size: 14px;\n  padding: 12px;\n  line-height: 1.4;\n}\n\n.Toastify__progress-bar {\n  background: rgba(255, 255, 255, 0.7);\n}\n\n/* Add these styles if you want to customize the close button */\n.Toastify__close-button {\n  color: white;\n  opacity: 0.7;\n}\n\n.Toastify__close-button:hover {\n  opacity: 1;\n}\n\n.button-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #ffffff;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.status-dropdown-select {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  border: none; /* Remove border */\n  background-color: transparent; /* Make background transparent */\n  cursor: pointer;\n  min-width: 150px;\n  appearance: none; /* Remove default dropdown appearance */\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  position: relative;\n  color: #374151; /* Default text color */\n}\n\n.status-dropdown:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n/* Status-specific colors */\n.status-dropdown.status-pending {\n  color: #ca8a04;\n  background-color: #fef9c3;\n}\n.status-dropdown.status-in-transit {\n  color: #854d0e;\n  background-color: #fef9c3;\n}\n.status-dropdown.status-completed {\n  color: #166534;\n  background-color: #dcfce7;\n}\n.status-dropdown.status-canceled {\n  color: #991b1b;\n  background-color: #fee2e2;\n}\n\n.status-dropdown.status-declined {\n  color: #991b1b;\n  background-color: #fee2e2;\n}\n.status-dropdown.status-processing {\n  color: #1d4ed8;\n  background-color: #dbeafe;\n}\n/* Add more status-specific colors as needed */\n\n.status-loading-select {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #6b7280;\n  padding: 6px 12px;\n}\n\n.status-spinner-select {\n  width: 12px;\n  height: 12px;\n  border: 2px solid #f3f4f6;\n  border-top: 2px solid #f97316;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
